import axios, { getOnce } from '@/plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async index(leadId: number) {
        if (!leadId) {
            throw new InvalidPayload('Lead ID not provided.');
        }

        const response = await getOnce(`v1/leads/${leadId}/communications`);
        if (response === null) {
            return null;
        }

        return response.data;
    },

    async show(id: number): Promise<unknown> {
        if (!id) {
            throw new InvalidPayload('Communication ID not provided.');
        }

        const response = await axios.get(`v1/communications/${id}`);

        return response.data.data;
    },
};
